/**
 * Check whether a user has permission to perform an action on a menu.
 *
 * @param {object|null} user   - The current user object (from /api/auth/me or localStorage)
 * @param {string}      menu   - Menu key, e.g. "sales", "clients", "appointments"
 * @param {string}      action - One of: "add", "edit", "delete", "print"
 * @returns {boolean}
 */
export const canDo = (user, menu, action) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const actions = user.menuActions?.[menu];
  return Array.isArray(actions) && actions.includes(action);
};
